import LocationCount from '../../../page-fragments/location-directory/LocationCount';
import renderer from '../../renderer';
import { useEffect } from 'react';
import {
  GenericRendererComponent,
  RendererComponentType,
  RendererSelectorType,
} from '../../../types/renderer';

const componentsRegister: GenericRendererComponent[] = [
  {
    componentType: RendererComponentType.GENERIC,
    selectorType: RendererSelectorType.ATTRIBUTE,
    selector: '[data-element-group="location-directory"][data-element-type="count"]',
    component: ({
      /* 
        data-filter-by-state: Pass this value only when on the individual state page
      */
      'data-filter-by-state': filterByState,
      'data-state': state,
      'data-city': city,
      'data-prefix': prefix,
      'data-suffix': suffix,
      'data-show-count-threshold': showCountThreshold,
      'data-replace-count-with': replaceCountWith,
    }) => {
      const locationIdentifiers = state && city ? [state, city] : state ? [state] : undefined;
      const showCountThresholdValue = 
        showCountThreshold 
          ? typeof showCountThreshold === 'number' 
        ? showCountThreshold 
        : parseInt(showCountThreshold, 10) || undefined 
          : undefined;

      return (
        locationIdentifiers && (
          <LocationCount
            locationIdentifiers={locationIdentifiers as [string] | [string, string]}
            filterByState={filterByState}
            prefix={prefix}
            suffix={suffix}
            showCountThreshold={showCountThresholdValue}
            replaceCountWith={replaceCountWith}
          />
        )
      );
    },
  },
];

function LocationDirectory() {
  useEffect(() => {
    renderer(componentsRegister);
  }, []);

  return null;
}

export default LocationDirectory;
